export default __webpack_public_path__ + "static/stickingout-d1c49aedde8265b9e547950ad4a5d1eb.png";